export default "__VITE_ASSET__DGyhYddw__"